<template>
  <ul class="mypage-link-list-parts">
    <template v-for="(v, i) in links">
      <li v-if="v.modalId && v.isDisplay" :key="i" class="mypage-link-list-parts__item">
        <button
          class="mypage-link-list-parts__link"
          :class="{ 'mypage-link-list-parts__link--disabled': v.isDisabled }"
          @click="handleOpenModalClicked(v.modalId)"
        >
          <span>{{ v.name }}</span>
          <img :src="require('@/assets/img/icon/icon_chevron_right_24.svg')" alt="" />
        </button>
      </li>
      <li v-else-if="v.isDisplay" :key="i" class="mypage-link-list-parts__item">
        <router-link
          v-if="!v.blank"
          :to="v.link"
          class="mypage-link-list-parts__link"
          :class="{ 'mypage-link-list-parts__link--disabled': v.isDisabled }"
        >
          <span>{{ v.name }}</span>
          <span
            v-if="v.subName"
            class="mypage-link-list-parts__link-sub-name"
            :class="{ 'mypage-link-list-parts__link-sub-name-error': v.hasError }"
          >
            <span class="mypage-link-list-parts__link-div">：</span>
            <span>{{ v.subName }}</span>
          </span>
          <img :src="require('@/assets/img/icon/icon_chevron_right_24.svg')" alt="" />
        </router-link>

        <a v-else :href="v.link" target="_blank" class="mypage-link-list-parts__link">
          <span>{{ v.name }}</span>
          <img :src="require('@/assets/img/icon/icon_external_link_outline.svg')" alt="" />
        </a>
      </li>
    </template>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * マイページ: トップ リンクリスト パーツ
 */
export default defineComponent({
  name: 'MypageLinkListParts',
  props: {
    /**
     * リンク情報リスト
     */
    links: {
      type: Array,
      required: true,
    },
  },
  setup(_, { emit }) {
    const handleOpenModalClicked = (modalId: string) => {
      emit('onClickOpenModal', modalId)
    }
    return {
      handleOpenModalClicked,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-link-list-parts {
  width: 100%;
  margin-bottom: 24px;
  background: $white;

  &__item {
    &:last-child .mypage-link-list-parts__link {
      padding-bottom: 17px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  &__link {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
    padding: 17px 40px 16px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: $black80;
    font-weight: 700;

    &-sub-name {
      font-weight: 400;

      &-error {
        color: $red;
      }
    }

    &-div {
      margin: 0 1em;
    }

    img {
      position: absolute;
      top: 50%;
      right: 16px;
      width: 24px;
      height: 24px;
      transform: translateY(-50%);
    }

    &--disabled {
      pointer-events: none;

      img {
        opacity: 0.4;
      }
    }
  }
}

@media screen and (min-width: $responsiveMypageMaxWidth) {
  .mypage-link-list-parts {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
